import AppPopover from "@/components/AppPopover";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import SpendBar from "@/components/brand_portfolio/SpendBar.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import BrandPortfolioMixin from "@/mixins/BrandPortfolioMixin.vue";
import BrandPortfolioStrategyMixin from "@/mixins/BrandPortfolioStrategyMixin.vue";
export default {
  name: "BrandPortfolioSpendCell",
  components: {
    AppPopover,
    CurrencyValue,
    PercentageValue,
    SpendBar,
    LoadingElement
  },
  mixins: [BrandPortfolioMixin, BrandPortfolioStrategyMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    },
    isLastSellerInWorkspace: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    budgetLineDashArray(portfolio) {
      return this.ppcForecastStatus(portfolio) == "ALERT" ? "2 4" : "none";
    }
  }
};